/*eslint-disable */
import LayerService from '@/services/layers/LayerService';
import store from '@/store/index';
import {
  LayerGroup, LeafletEvent, Marker, DivIcon,
  markerClusterGroup,
} from 'leaflet';
import { IFeatureCollection } from '@/interfaces/IFeatureCollection';
import { IWeatherStatus } from '@/interfaces/IWeatherStatus';
import { IModalData } from '@/services/layers/IModalData';
import AssetIconService from '@/services/AssetIconService';
import { toRaw } from 'vue';
import MapIconsGeneratorService from '../MapIconsGeneratorService';
import { IClusterIconSettings, IMarkerIconSettings } from '@/interfaces/IMapIconsSettings';

export default class WeatherStationsLayerService extends LayerService {
  onClick = (e: LeafletEvent, metaData: any, leafletMarker: Marker<any>): void => {
    const currentWeather: IWeatherStatus = metaData.last_status as IWeatherStatus;

    const lastUpdate = metaData.last_status ? metaData.last_status.time : '';
    let modalIconUrl: string = AssetIconService.getSvgModalIcon('modal_weather_station');

    const modalData: IModalData = {
      title: metaData.name,
      content: '',
      navigationPoint: undefined,
      lastUpdate: lastUpdate,
      icon: modalIconUrl,
      templateName: 'TemplateModalWeatherStation',
      metaData: metaData,
      iconClassName: '',
    };

    store.commit('displayModal', modalData);
  };

  redrawLayer = (): LayerGroup<any> => {
    const points: IFeatureCollection = store.state.weatherStations;

    return this.generateMarkerClusterLayer(points);
  };

  protected generateMarkerClusterLayer = (positions: IFeatureCollection): LayerGroup => {
    const markerClusterGroupInstance = markerClusterGroup({
      showCoverageOnHover: false,
      maxClusterRadius: 40,
      iconCreateFunction: (cluster) => {
        const population = cluster.getChildCount();
        return new DivIcon({
          html: this.generateClusterHtml(population),
          className: 'custom-cluster-icon',
          iconSize: [this.clusterWidth, this.clusterHeight],
          iconAnchor: [this.clusterWidth / 2, this.clusterHeight / 2],
        });
      },
    });

    positions.features.forEach((feature: any) => {
      if (!feature.geometry) return;

      const { coordinates } = feature.geometry;
      const [lng, lat] = coordinates as Array<number>;

      const singleMarker = this.createMarker({ lat, lng }, feature);
      markerClusterGroupInstance.addLayer(toRaw(singleMarker));
    });

    return markerClusterGroupInstance;
  };

  generateClusterHtml(population: number) {
      const settings: IClusterIconSettings = {
        className: 'g__color--weather',
        insideIcon:  require(`@/assets/img/icon-layers/single-icons/marker_weather_station.svg`),
        population,
      };
      const iconHtml = MapIconsGeneratorService.getClusterIcon(settings);
      
      return iconHtml;
    }
  
    protected generateHtmlPointTemplate = (metaData: any): string => {
      const settings: IMarkerIconSettings = {
        className: 'g__color--weather',
        insideIcon:  require(`@/assets/img/icon-layers/single-icons/marker_weather_station.svg`),
      };
      const iconHtml = MapIconsGeneratorService.getMarkerIcon(settings);
  
      return iconHtml;
    };
}
